/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpCloudSqlRestoreDestination } from '../models/GcpCloudSqlRestoreDestination';

export class RestoreGcpCloudSqlRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': GcpCloudSqlRestoreDestination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "GcpCloudSqlRestoreDestination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreGcpCloudSqlRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

